import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CheckBoxField } from '@unite-us/ui';
import { noop, get, isEmpty } from 'lodash';
import { phoneCanReceiveOralCommunication, phoneCanReceiveWrittenCommunication } from '../utils';
import CommunicationTypesCheckBoxes from '../CommunicationTypesCheckBoxes';
import PhoneNumberField from '../PhoneNumberField';
import PhoneTypeField from '../PhoneTypeField';
import { RemovePhoneButton, RemovePhoneConfirmation } from './components';
import focusExtensionIfPhoneNumberValid from '../../../../utils/focusExtensionIfPhoneNumberValid';
import './stylesheets/profilePhoneFields.scss';
import { Field, useForm } from 'react-final-form';
import { composeValidators } from '../../../../utils/composeValidators';
import { isNumber, isPhoneNumber, isRequired } from '../../../../utils/validations';
var ProfilePhoneFields = function ProfilePhoneFields(props) {
  var index = props.index,
    phoneFor = props.phoneFor,
    styles = props.styles,
    onRemove = props.onRemove,
    fieldName = props.fieldName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRemove = _useState2[0],
    setShowRemove = _useState2[1];
  var communicationCheckboxesRef = useRef({});
  var form = useForm();
  var phones = get(form.getFieldState("phones"), 'value', []);
  var phoneValue = get(phones, "[".concat(index, "]"), {});
  useEffect(function () {
    enforcePrimaryField();
  });
  var enforcePrimaryField = function enforcePrimaryField() {
    // Set the first phone as primary if none exists
    if (isEmpty(phones)) return;
    var hasPrimary = phones.some(function (p) {
      return !!p.is_primary;
    });
    if (!hasPrimary && index === 0) {
      var primaryField = form.getFieldState("".concat(fieldName, ".is_primary"));
      primaryField.change(true);
    }
  };
  var onPrimaryChanged = function onPrimaryChanged(params) {
    var _context;
    var phones = _filterInstanceProperty(_context = form.getRegisteredFields()).call(_context, function (rf) {
      return _endsWithInstanceProperty(rf).call(rf, "is_primary");
    });
    phones.forEach(function (p) {
      if (!_includesInstanceProperty(p).call(p, params.input.name)) form.change(p, false);
    });
  };
  var onCancelRemove = function onCancelRemove() {
    setShowRemove(false);
  };
  var onConfirmRemove = function onConfirmRemove() {
    setShowRemove(false);
    onRemove(phoneValue);
  };
  var handleAutoTab = function handleAutoTab(event) {
    var extensionInputBox = document.getElementById("".concat(event.target.name.replace('phone_number', 'extension')));
    focusExtensionIfPhoneNumberValid(event.target.value, extensionInputBox);
  };
  var onTypeChange = function onTypeChange(params) {
    var newValue = get(params, 'input.value.value');
    if (newValue) {
      params.input.onChange(newValue);
    }

    // Clear all communication check boxes when changing types.
    _Object$values(communicationCheckboxesRef.current).forEach(function (ch) {
      return ch.input.onChange();
    });
  };
  var showRemoveConfirmation = function showRemoveConfirmation() {
    setShowRemove(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "profile-phone-fields"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-2 text-right pt-quarter"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "inline-phone-label"
  }, "Phone")), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-4 profile-phone-fields__phone-number"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row phone-number-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-8 pr-0",
    "data-test-element": "phone_number_input"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".phone_number"),
    validate: composeValidators(isPhoneNumber, isRequired)
  }, function (params) {
    return /*#__PURE__*/React.createElement(PhoneNumberField, _extends({
      autoFocus: true,
      id: "".concat(fieldName, ".phone_number"),
      placeholder: "(xxx) xxx-xxxx",
      mask: "(999) 999-9999",
      onChange: handleAutoTab
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-4 pr-0",
    title: "Phone Number Extension",
    "data-test-element": "phone_extension_input"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".extension"),
    validate: isNumber
  }, function (params) {
    return /*#__PURE__*/React.createElement(PhoneNumberField, _extends({
      id: "".concat(fieldName, ".extension"),
      placeholder: "ext.",
      mask: ""
    }, params));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-3 profile-phone-fields__phone-type"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".phone_type"),
    validate: isRequired
  }, function (params) {
    return /*#__PURE__*/React.createElement(PhoneTypeField, _extends({
      id: "".concat(fieldName, ".phone_type"),
      onChange: function onChange() {
        return onTypeChange(params);
      },
      phoneFor: phoneFor,
      valueKey: "value"
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-2 profile-phone-fields__is-primary"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "".concat(fieldName, ".is_primary")
  }, function (params) {
    return /*#__PURE__*/React.createElement(CheckBoxField, _extends({
      label: "Primary",
      id: "".concat(fieldName, ".is_primary"),
      onChange: function onChange() {
        onPrimaryChanged(params);
      },
      style: {
        marginTop: '38px'
      }
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-1",
    style: showRemove ? styles.fadeRemove : styles.showRemove
  }, onRemove && /*#__PURE__*/React.createElement(RemovePhoneButton, {
    onClick: showRemoveConfirmation
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-10"
  }, /*#__PURE__*/React.createElement(CommunicationTypesCheckBoxes, {
    id: "".concat(index, "-communication-types-checkboxes"),
    hideOralTypes: !phoneCanReceiveOralCommunication(phoneValue.phone_type),
    hideWrittenTypes: !phoneCanReceiveWrittenCommunication(phoneValue.phone_type),
    fieldName: "".concat(fieldName, ".acceptable_communication_types"),
    phone: true,
    setCheckboxesRef: function setCheckboxesRef(params) {
      return communicationCheckboxesRef.current[params.input.name] = params;
    }
  }))), /*#__PURE__*/React.createElement(RemovePhoneConfirmation, {
    show: showRemove,
    onCancel: onCancelRemove,
    onConfirm: onConfirmRemove
  }));
};
ProfilePhoneFields.propTypes = {
  onRemove: PropTypes.func,
  phoneFor: PropTypes.oneOf(['contact', 'group']),
  styles: PropTypes.object,
  index: PropTypes.number.isRequired
};
ProfilePhoneFields.defaultProps = {
  onRemove: noop,
  phoneFor: 'contact',
  styles: {
    fadeRemove: {
      opacity: '.3'
    },
    showRemove: {
      visibility: 'visible'
    },
    hideRemove: {
      visibility: 'hidden',
      display: 'none'
    },
    checkbox: {
      marginTop: '8px'
    }
  }
};
export default ProfilePhoneFields;
//# sourceMappingURL=index.js.map